module.exports = __webpack_public_path__ + "img/c03_buildingtechcoinage_Normal_ua.7f6de979.webp";